module.exports = __WEBPACK_EXTERNAL_MODULE_14__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"fetch-ponyfill"}
// module id = 14
// module chunks = 0 1